import BookingSummarySkeleton from '@/components/booking-summary/BookingSummarySkeleton';
import SectionSkeleton from '@/components/purchase/checkout/SectionSkeleton';
import { breakpoints } from '@/utils/breakpoints';
import { Card, Divider, Skeleton } from '@packages/webshop-design-system';
import type { FC } from 'react';
import { useMediaQuery } from 'react-responsive';

// Shown while `useJourneyChangeCheckout` commits the exchange. It mirrors the
// change-trips (`hasSelection`) checkout layout — which skips the passenger step,
// inherited and locked — so the hand-off to `Checkout` doesn't shift the layout.
const JourneyChangeCheckoutSkeleton: FC = () => {
  const isLaptopOrBigger = useMediaQuery({ minWidth: breakpoints.laptop });

  return (
    <div
      className="mx-auto flex w-full max-w-laptop items-start gap-8 p-4 pb-36 laptop:pb-24"
      data-testid="journey-change-checkout-committing"
    >
      <div className="flex w-full flex-1 flex-col gap-4">
        <div className="sticky top-0 z-10 flex justify-between bg-background py-2">
          <Skeleton className="h-8 w-64" />
        </div>
        {(
          ['seatSelection', 'ancillaries', 'purchaser', 'consents'] as const
        ).map((type) => (
          <Card key={type} className="p-0">
            <div className="flex flex-col gap-3 p-3 pb-4 laptop:p-6 laptop:pt-4">
              <div className="flex gap-0.5">
                <Skeleton className="h-6 w-40" />
              </div>
              <Divider variant="medium" />
              <SectionSkeleton type={type} />
            </div>
          </Card>
        ))}
      </div>

      {isLaptopOrBigger && (
        <div className="sticky top-0 flex flex-col gap-4">
          <div className="flex justify-between py-2">
            <Skeleton className="h-7 w-40" />
          </div>
          <BookingSummarySkeleton variant="regular" />
        </div>
      )}
    </div>
  );
};

export default JourneyChangeCheckoutSkeleton;
